import definition from './navigation.service';

/**
 * NavigationService settings
 * @type {{name: string, definition: NavigationService}}
 */
export default {
    name: 'NavigationService',
    definition
};



// WEBPACK FOOTER //
// ./app/services/navigation/index.js